import gql from "graphql-tag";

export const MY_HR_VERIFY_2FA_EMAIL_CODE = gql`
  mutation verify2faEmailCode($code: String!) {
    verify2faEmailCode(code: $code)
  }
`;
